import React from 'react';
import { MIN_VALOR_ATE_POR_TIPO } from '../../constants';

const CHIPS = [
  { tipo: 1, prefixo: 'R$ 2,2', destaque: '9' },
  { tipo: 2, prefixo: 'R$ 2,', destaque: '99' },
  { tipo: 3, prefixo: 'R$ 2', destaque: '9,99' },
  { tipo: 4, prefixo: 'R$ 2', destaque: '99,99' },
  { tipo: 5, prefixo: 'R$ 2.', destaque: '999,99' },
] as const;

interface Props {
  value: number;
  valorAte?: number;
  onChange: (tipo: number) => void;
  disabled?: boolean;
}

export function TipoSeletorDigitos({ value, valorAte = 0, onChange, disabled }: Props) {
  return (
    <div className="dts">
      <div className="dts__header">
        <span className="dts__titulo">Dígitos arredondados</span>
        <span className="dts__subtitulo">
          Defina quantos dígitos serão arredondados, da direita para a esquerda
        </span>
      </div>
      <div className="dts__chips">
        {CHIPS.map(({ tipo, prefixo, destaque }) => {
          const habilitado = !disabled && valorAte >= MIN_VALOR_ATE_POR_TIPO[tipo];
          const selecionado = value === tipo;
          return (
            <button
              key={tipo}
              type="button"
              className={[
                'dts__chip',
                selecionado ? 'dts__chip--ativo' : '',
                !habilitado ? 'dts__chip--desabilitado' : '',
              ].filter(Boolean).join(' ')}
              disabled={!habilitado}
              onClick={() => onChange(tipo)}
            >
              <span className={[
                'dts__chip-numero',
                selecionado ? 'dts__chip-numero--ativo' : '',
                !habilitado ? 'dts__chip-numero--desabilitado' : '',
              ].filter(Boolean).join(' ')}>
                {tipo}
              </span>
              <span className="dts__chip-espaco">{`  `}</span>
              <span className={`dts__chip-prefixo${!habilitado ? ' dts__chip-prefixo--desabilitado' : ''}`}>
                {prefixo}
              </span>
              <span className={`dts__chip-destaque${!habilitado ? ' dts__chip-destaque--desabilitado' : ''}`}>
                {destaque}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
